import React from "react";
import { DateOrString, formatDateOrString } from "./dates";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";

export const InlineDateField: React.FC<{
    label: string;
    value: DateOrString | null | undefined;
}> = ({ label, value }) => {
    if (!value) {
        return null;
    }

    const formatted = value ? formatDateOrString(value) : "-";

    return (
        <DescriptionListItem layout="columns" label={label}>
            <span>{formatted}</span>
        </DescriptionListItem>
    );
};
